/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import { MarketsState, MarketsTypes } from './types';

const INITIAL_STATE: MarketsState = {
  filterSegment: '',
  searchBar: '',
  city: '',
  state: '',
  merchantsList: [],
  segmentsList: [],
};

const reducer: Reducer<MarketsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MarketsTypes.FILTER_SEGMENT:
      return {
        ...state,
        filterSegment: action.payload,
      };
    case MarketsTypes.FILTER_MERCHANT:
      return {
        ...state,
        searchBar: action.payload,
      };
    case MarketsTypes.HANDLE_POSITION:
      return {
        ...state,
        city: action.payload.city,
        state: action.payload.state,
      };
    case MarketsTypes.HANDLE_MERCHANTS:
      return {
        ...state,
        merchantsList: action.payload,
      };

    case MarketsTypes.UPDATE_MERCHANT_AVAILABILITY:
      return {
        ...state,
        merchantsList: state.merchantsList.map(m =>
          m.id === action.payload.merchantId
            ? { ...m, status: action.payload.availability }
            : m,
        ),
      };

    case MarketsTypes.HANDLE_SEGMENTS:
      return {
        ...state,
        segmentsList: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
